export const normalizePreviewFieldValue = (value) =>
  String(value ?? "").replace(/ /g, "\u00A0");

export const getFirstAttendeeFieldValues = (spreadsheetData) => {
  if (!spreadsheetData?.fileData || !spreadsheetData?.mapping) {
    return {};
  }

  const { mapping, fileData } = spreadsheetData;
  const headers = fileData.headers || [];
  const firstRow = fileData.data?.[0] || [];

  return Object.entries(mapping).reduce((fieldValues, [header, fieldName]) => {
    const columnIndex = headers.indexOf(header);
    if (columnIndex !== -1) {
      const value = firstRow[columnIndex];
      fieldValues[fieldName] = value != null ? String(value).trim() : "";
    }
    return fieldValues;
  }, {});
};

export const getTemplateWithFirstAttendee = (template, spreadsheetData) => {
  const fieldValues = getFirstAttendeeFieldValues(spreadsheetData);
  const fieldNames = Object.keys(fieldValues);

  if (!template || !fieldNames.length) {
    return template;
  }

  return {
    ...template,
    fields: (template.fields || []).map((field) =>
      Object.prototype.hasOwnProperty.call(fieldValues, field.label)
        ? {
            ...field,
            value: normalizePreviewFieldValue(fieldValues[field.label]),
          }
        : field
    ),
  };
};
